import "@hey-lady/shared/static/css/fonts.css";
import { createRoot } from "react-dom/client";
import Root from "./core/Root";
import { bootSentry } from "./core/sentry";

// Sentry boots lazily on idle (QW4) — the SDK is dynamically imported so it
// never blocks first paint. Pre-boot errors are queued and replayed on boot.
bootSentry();

const container = document.getElementById("root") as Element;
const root = createRoot(container);
root.render(<Root />);
